import { render, staticRenderFns } from "./observationdatasetstate.vue?vue&type=template&id=51fbbe64&scoped=true"
import script from "./observationdatasetstate.vue?vue&type=script&lang=js"
export * from "./observationdatasetstate.vue?vue&type=script&lang=js"
import style0 from "./observationdatasetstate.vue?vue&type=style&index=0&id=51fbbe64&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51fbbe64",
  null
  
)

export default component.exports